/* Presentation adapter only. The voting app owns all requests, counts and event rules. */
(() => {
  'use strict';
  function start() {
    const page = window.VP && window.VP.currentPage;
    if (!page) return;
    document.querySelectorAll('.dac-voting-content').forEach(root => {
      if (root.dataset.dacVotingMounted) return;
      const grid = root.querySelector('#vp-page-images');
      const count = root.querySelector('#vp-page-total-votes');
      if (!grid || !count) return;
      let copy;
      try { copy = JSON.parse(root.querySelector('[data-dac-voting-copy]').textContent); } catch (_) { return; }
      const shell = grid.parentElement;
      const originalHeading = root.querySelector('h2,h1');
      const countParagraph = count.closest('p');
      const description = countParagraph && countParagraph.parentElement;
      root.dataset.dacVotingMounted = 'true';
      root.dataset.dacEventEnded = String(page.is_ended === true);

      // Normalize the actual wrappers, without relying on a Shopify-generated wrapper class.
      for (let node = shell; node && node !== root; node = node.parentElement) node.dataset.dacVotingLayout = 'true';
      const summary = document.createElement('div'); summary.className = 'dac-voting-summary';
      const heading = document.createElement('h2');
      const shared = Boolean(new URL(location.href).searchParams.get('share_key'));
      heading.textContent = page.is_ended ? (shared ? copy.shared_picks : copy.your_picks) : copy.choose;
      summary.append(heading);
      if (page.is_ended) {
        const closed = document.createElement('span'); closed.className = 'dac-voting-closed'; closed.textContent = copy.closed;
        summary.append(closed);
      }
      const total = document.createElement('p'); total.className = 'dac-voting-total';
      total.append(document.createTextNode(copy.votes + ' '), count);
      summary.append(total);
      if (originalHeading) originalHeading.before(summary); else shell.prepend(summary);
      if (originalHeading) originalHeading.hidden = true;
      if (countParagraph) countParagraph.hidden = true;
      // Keep active-event instructions; replace only the ended event's generic promotional message.
      if (page.is_ended && description && description !== shell && !description.contains(grid)) description.hidden = true;
      grid.dataset.emptyCopy = copy.empty;
      const modal = document.getElementById('vp-images-modal');
      if (modal && window.DACCloseControl) {
        const close = modal.querySelector('[data-vp-modal-navigation="close"]');
        window.DACCloseControl.apply(close, copy.close);
        if (close) close.dataset.dacCloseOverlay = 'true';
      }
      if (modal && window.DACLibraryCards) {
        const panel = modal.querySelector('.modal');
        const close = modal.querySelector('[data-vp-modal-navigation="close"]');
        let opener = null, controller = null;
        if (panel && close) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          panel.setAttribute('aria-label', copy.preview_title);
          panel.tabIndex = -1;
          const previewImage = modal.querySelector('[data-vp-modal-image-preview]');
          if (previewImage) previewImage.alt = copy.preview_title;
          const enhanceCards = () => grid.querySelectorAll('.vp-image-card-element[data-vp-image-id]').forEach((card, index) => {
            const label = copy.preview + ' ' + (index + 1);
            card.setAttribute('role', 'button'); card.tabIndex = 0;
            card.setAttribute('aria-label', label);
            const image = card.querySelector('[data-vp-image-img]');
            if (image && !image.alt) image.alt = label;
          });
          enhanceCards();
          new MutationObserver(enhanceCards).observe(grid, { childList: true });
          grid.addEventListener('click', event => { opener = event.target.closest('.vp-image-card-element'); }, true);
          grid.addEventListener('keydown', event => {
            const card = event.target.closest('.vp-image-card-element');
            if (!card || event.target !== card || !['Enter', ' '].includes(event.key)) return;
            event.preventDefault(); card.click();
          });
          const syncDialog = () => {
            const open = getComputedStyle(modal).display !== 'none';
            if (open && !controller) controller = window.DACLibraryCards.openModal(modal, opener, { persistent: true, onClose: () => close.click() });
            else if (!open && controller) { controller.release(); controller = null; }
            modal.querySelectorAll('[data-vp-modal-navigation]:not([data-vp-modal-navigation="close"])').forEach(button => {
              const disabled = button.classList.contains('vp-disabled');
              button.setAttribute('role', 'button');
              button.setAttribute('aria-label', button.textContent.trim());
              button.setAttribute('aria-disabled', String(disabled));
              button.tabIndex = disabled ? -1 : 0;
              if (button.tagName === 'BUTTON') button.disabled = disabled;
            });
          };
          modal.addEventListener('keydown', event => {
            const button = event.target.closest('[data-vp-modal-navigation]');
            if (!button || button.tagName === 'BUTTON' || !['Enter', ' '].includes(event.key)) return;
            event.preventDefault();
            if (button.getAttribute('aria-disabled') !== 'true') button.click();
          });
          new MutationObserver(syncDialog).observe(modal, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
          syncDialog();
        }
      }
      if (modal && window.DACVotesImageGestures) window.DACVotesImageGestures.bind({
        surface: modal.querySelector('.image-container'), dialog: modal.querySelector('.modal'),
        isOpen: () => getComputedStyle(modal).display !== 'none',
        close: () => modal.querySelector('[data-vp-modal-navigation="close"]')?.click(),
        resetOn: modal
      });
    });
  }
  const afterAppListeners = () => queueMicrotask(start);
  window.addEventListener('vp-app-loaded', afterAppListeners);
  window.addEventListener('vp-app-customer-auth', afterAppListeners);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterAppListeners, { once: true }); else afterAppListeners();
  document.addEventListener('shopify:section:load', afterAppListeners);
})();

